import type { SVGProps } from 'react';

const AddItemIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={18}
    height={18}
    fill='none'
    {...props}>
    <path
      fill='#696F88'
      fillRule='evenodd'
      d='M1.5 3.75h9v1.5h-9v-1.5Zm0 3h9v1.5h-9v-1.5Zm12 0H12v3H9v1.5h3v3h1.5v-3h3v-1.5h-3v-3Zm-6 4.5h-6v-1.5h6v1.5Z'
      clipRule='evenodd'
    />
  </svg>
);

export default AddItemIcon;
